import FormattedMessage from 'I18n/components/FormattedMessage';
import { useEffect, useRef, useState } from 'react';
import { Button } from 'foundations-components/transitional/components/Button';
import { DialogBody } from 'foundations-components/transitional/components/DialogBody';
import { DialogFooter } from 'foundations-components/transitional/components/DialogFooter';
import { Modal } from 'foundations-components/transitional/components/Modal';
import { TFlex } from 'foundations-components/transitional/components/TFlex';
import { Tooltip } from 'foundations-components/transitional/components/Tooltip';
import { Text } from 'foundations-components/components/Text';
import { tracker } from '../../../common/eventTracking/tracker';
import { handleSubmitSurveyResponses } from '../../../utils/trialFeatureSurveySubmit';
import { proDefaultSurveyResponseMap } from '../../SurveyResponses';
import { FeatureSurveyModalHeader } from './FeatureSurveyModalHeader';
import FeatureSurveyRow from './FeatureSurveyRow';
import { jsx as _jsx } from "react/jsx-runtime";
import { jsxs as _jsxs } from "react/jsx-runtime";
const FeatureSurveyModal = ({
  apiName,
  setInitialSuccessModal,
  upgradeData
}) => {
  const lastApiName = useRef(apiName);
  const [allFeatures, setSelectedFeatures] = useState(proDefaultSurveyResponseMap[apiName]);
  const featureData = Object.values(allFeatures);
  const isDisabled = featureData.every(({
    isSelected
  }) => !isSelected);
  useEffect(() => {
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'viewed pricing page survey modal'
    }, upgradeData));
    if (lastApiName.current !== apiName) {
      setSelectedFeatures(() => proDefaultSurveyResponseMap[apiName]);
      lastApiName.current = apiName;
    }
  }, [upgradeData, apiName]);
  const handleSubmitSelectedFeatures = async () => {
    await handleSubmitSurveyResponses(apiName, allFeatures, upgradeData);
    setInitialSuccessModal();
  };
  const handleSkip = () => {
    tracker.track('trialActivationInteraction', Object.assign({
      action: 'survey skipped'
    }, upgradeData));
    setInitialSuccessModal();
  };
  const handleSelectedFeatureChange = (featureKey, isSelected) => {
    const newSelectedFeatures = Object.assign({}, allFeatures, {
      [featureKey]: Object.assign({}, allFeatures[featureKey], {
        isSelected
      })
    });
    setSelectedFeatures(newSelectedFeatures);
  };
  return /*#__PURE__*/_jsxs(Modal, {
    use: "success",
    width: 750,
    size: "auto",
    centered: true,
    children: [/*#__PURE__*/_jsx(FeatureSurveyModalHeader, {}), /*#__PURE__*/_jsxs(DialogBody, {
      children: [/*#__PURE__*/_jsx(Text, {
        typography: "body-125",
        marginBlockEnd: "400",
        children: /*#__PURE__*/_jsx(FormattedMessage, {
          message: "upgrades.trialFeatureSurvey.common.headline"
        })
      }), /*#__PURE__*/_jsx(TFlex, {
        align: "center",
        direction: "column",
        gap: 32,
        margin: "0",
        marginBlockStart: "200",
        children: /*#__PURE__*/_jsx(FeatureSurveyRow, {
          features: featureData,
          onSelectionChange: handleSelectedFeatureChange
        }, 'feature-survey-row')
      })]
    }), /*#__PURE__*/_jsx(DialogFooter, {
      children: /*#__PURE__*/_jsxs(TFlex, {
        align: "center",
        direction: "column",
        gap: 16,
        margin: "0",
        marginBlockStart: "200",
        children: [/*#__PURE__*/_jsx(Tooltip, {
          title: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialFeatureSurvey.common.tooltip"
          }),
          disabled: !isDisabled,
          children: /*#__PURE__*/_jsx(Button, {
            use: "primary",
            onClick: () => {
              handleSubmitSelectedFeatures().catch(() => {});
            },
            disabled: isDisabled,
            children: /*#__PURE__*/_jsx(FormattedMessage, {
              message: "upgrades.trialFeatureSurvey.common.submitButton"
            })
          })
        }), /*#__PURE__*/_jsx(Button, {
          use: "link",
          onClick: handleSkip,
          margin: "0",
          children: /*#__PURE__*/_jsx(FormattedMessage, {
            message: "upgrades.trialFeatureSurvey.common.skipButton"
          })
        })]
      })
    })]
  });
};
export default FeatureSurveyModal;